import { isEqual } from 'lodash';
import { targetingConstants } from 'sonata-platform-components';

import { TARGETING_DEMOGRAPHY_MAX_AGE, TARGETING_DEMOGRAPHY_MIN_AGE } from '../Demography';

import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';
import type { TagItem } from '@/components/common/FormExpandableSection/FormExpandableSection';

const { DEFAULT_DEMOGRAPHY } = targetingConstants;

export function getDemographyTags(
  ages: TargetingBaseType['ages'],
  gender: TargetingBaseType['gender'],
  languages: TargetingBaseType['languages']
): TagItem[] {
  const result: TagItem[] = [];
  if (!isEqual(ages, DEFAULT_DEMOGRAPHY.ages)) {
    const min = ages[0]?.min || String(TARGETING_DEMOGRAPHY_MIN_AGE);
    const max = ages[0]?.max || String(TARGETING_DEMOGRAPHY_MAX_AGE);
    result.push({ label: `Ages: ${min}-${max}` });
  }
  if (!isEqual(gender, DEFAULT_DEMOGRAPHY.gender)) {
    const genderLabel = gender[0] === 'f' ? 'Female' : gender[0] === 'm' ? 'Male' : 'All';
    result.push({ label: genderLabel });
  }
  if (!isEqual(languages, DEFAULT_DEMOGRAPHY.languages)) {
    result.push({ label: `${languages.length} language${languages.length !== 1 ? 's' : ''}` });
  }

  return result;
}
